import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import * as zVal from '../../../../lib/validations'
import RadioGroup from '../../../ui/radio-group';
import Button from '../../../ui/button';
import Text from '../../../ui/text';
import { paymentOptions } from '../constants';

const schema = z.object({
  paymentOption: zVal.textRequired(),
});

function PremiumDetails(props) {
  const { goToTab, updateData } = props;
  const methods = useForm({
    resolver: zodResolver(schema),
  });
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = (newData) => {

    updateData(newData);

    goToTab('signature');
  
  };

  return (
    <main className="flex">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="w-full">
          <section className="w-full">
            <h2 className="text-2xl font-semibold text-secondary">
              <Text>Paying your Plan Premium</Text>
            </h2>
            <p className='text-xl mt-5'>
              <Text>You can pay your monthly plan premium (including any late enrollment penalty that you currently or may owe) by mail. You can also choose to pay your premium by having it automatically taken out of your Social Security or Railroad Retirement Board (RRB) benefit each month.</Text>
            </p> 
          </section>
          <section className="mt-10 w-full">
            <h2 className="text-2xl font-semibold leading-none text-secondary">
              <Text>Payment options *</Text>
            </h2>
            <div className='w-full flex flex-col justify-start items-start mt-5'>
              <RadioGroup
                control={control}
                name='paymentOption'
                size='sm'
                orientation='vertical'
                options={paymentOptions} 
                isInvalid={!!errors?.paymentOption}
                errorMessage={errors?.paymentOption?.message || null}
              />
            </div>
          </section>
          <div className='w-full'>
            <div className="w-full flex flex-row justify-end gap-3 mt-5">
              <Button type='button' color='primary' variant='bordered' radius='full' onClick={() => goToTab('health')}><Text>Previous</Text></Button>
              <Button type='submit' color='primary' radius='full'><Text>Next</Text></Button>
            </div>
          </div> 
        </form>
      </FormProvider>
    </main>
  );
}

export default PremiumDetails;